import { useState } from "react";
import "./Wishlist.css";
import { IoIosCart, IoIosRemoveCircleOutline } from "react-icons/io";
import wishlistImg from "../assests/2.png";
import { addToCart } from "../redux/slices/cartSlice";
import { useDispatch } from "react-redux";
import { addtocart } from "../apis/Cart";

const Wishlist = ({
  wishlist,
  fetchbag,
  bag,
  updateQuantity,
  remove,
  products,
}) => {
  const [loadingProductId, setLoadingProductId] = useState(null);
  const dispatch = useDispatch();

  const handleRemove = (option, id) => {
    remove(option, id, "wishlist");
  };

  const handleAddToCart = async (product, type, price, size) => {
    if (loadingProductId === product.id) return;
    setLoadingProductId(product.id);

    try {
      await addtocart(product, type, fetchbag, price, size);
      dispatch(addToCart(product));
    } catch (error) {
      console.error("Failed to add to cart:", error);
    } finally {
      setLoadingProductId(null);
    }
  };

  return (
    <>
      {wishlist.length !== 0 ? (
        <section className="wishlist-section">
          <div className="wishlist-title">💖 My Wishlist</div>
          <div className="wishlist-cards">
            {wishlist.map((item) => {
              // Find matching product from products list
              const matchedProduct = products?.find(
                (product) => String(product.id) === String(item.product_id)
              );

              // Fallback to wishlist item if product data not found
              const productData = matchedProduct || item;

              // Extract price and size
              const price = productData?.discounted_amount
                ? productData.discounted_amount.split(",")[0]
                : productData?.prod_price?.split(",")[0];

              const size = productData?.prod_size?.split(",")[0];

              return (
                <article className="wishlist-card" key={item.id}>
                  <img
                    src={`${
                      process.env.REACT_APP_BASEURL
                    }/apis/vendor/uploads/products/${
                      item.prod_img.split(",")[0]
                    }`}
                    alt={item.prod_name}
                    className="wishlist-image"
                  />
                  <div className="wishlist-details">
                    <div className="wishlist-product">{item.prod_name}</div>
                    <span className="wishlist-price">
                      ₹{price}
                    </span>
                    <div className="wishlist-actions">
                      {bag.some(
                        (bagItem) =>
                          String(bagItem.product_id) === String(item.product_id)
                      ) ? (
                        bag
                          .filter(
                            (bagItem) =>
                              String(bagItem.product_id) ===
                              String(item.product_id)
                          )
                          .map((bagItem) => (
                            <div
                              className="quantity-controls"
                              key={bagItem.product_id}
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateQuantity(
                                    bagItem.product_id,
                                    -1,
                                    "cart"
                                  );
                                }}
                              >
                                -
                              </button>
                              <span>{bagItem.quantity}</span>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  updateQuantity(bagItem.product_id, 1, "cart");
                                }}
                              >
                                +
                              </button>
                            </div>
                          ))
                      ) :
                      //  productData?.stock.split(",")[0] > 0 ? (
                      //   <button
                      //     className="move-btn"
                      //     onClick={(e) => {
                      //       e.stopPropagation();
                      //       // const actualPrice = item?.discounted_amount
                      //       //   ? item.discounted_amount.split(",")[0]
                      //       //   : item.prod_price.split(",")[0];
                      //       handleAddToCart(
                      //         item.product_id,
                      //         "cart",
                      //         price,
                      //         size
                      //       );
                      //     }}
                      //   >
                      //     <IoIosCart />
                      //     {loadingProductId === item.product_id
                      //       ? "Adding..."
                      //       : "Add to Cart"}
                      //   </button>
                      // ) : 
                      (
                        <button className="move-btn out-of-stock" disabled>
                          Unavailable Stock
                        </button>
                      )}
                      {/* )} */}

                      <button
                        className="remove-btn"
                        onClick={() => handleRemove("delete", item.id)}
                      >
                        <IoIosRemoveCircleOutline />
                      </button>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      ) : (
        <div className="mt-cart-container">
          <img
            src={wishlistImg}
            alt="Empty Wishlist"
            className="empty-cart-image"
          />
        </div>
      )}
    </>
  );
};

export default Wishlist;
